<template>
	<button
			:class="[
					'secondary-btn btn button btn-round btn-lg w-full',
					'size-'+size,
					'width-'+width,
			]"
			@click.prevent.stop="onClick"
			:disabled="disabled"
	>
			{{ label }}
	</button>
</template>
<script>
	export default {
		name: 'SimplementsSecondaryButton',
		props: {
			label: {
				type: String
			},
			disabled: {
				type: Boolean
			},
			size: {
				type: String,
				default: 'lg'
			},
			width: {
				type: String,
				default: 'full'
			}
		},
		methods: {
			onClick(event){
				this.$emit('click', event)
			}
		}
	}
</script>
<style scoped>
	@import url(./assets/basic.css);
	.button.btn.secondary-btn,
	.button.btn.secondary-btn:hover,
	.button.btn.secondary-btn:active{
		
		border: 1px solid var(--neutral-10, rgba(51, 51, 51, 0.93));

		color: var(--neutral-10, rgba(51, 51, 51, 0.93));
	}
	.btn.secondary-btn:hover{
		border: 1px solid var(--neutral10, #333);
		background: var(--neutral80, #DFDFDF);
	}
</style>